// Prayer Times App - Mock Data & Utilities

export const defaultLocation = {
  city: 'Makkah',
  country: 'Saudi Arabia',
  latitude: 21.4225,
  longitude: 39.8262,
  timezone: 'Asia/Riyadh'
};

export const prayerNames = [
  { key: 'Fajr', arabic: 'الفجر', icon: 'sunrise' },
  { key: 'Dhuhr', arabic: 'الظهر', icon: 'sun' },
  { key: 'Asr', arabic: 'العصر', icon: 'sun-dim' },
  { key: 'Maghrib', arabic: 'المغرب', icon: 'sunset' },
  { key: 'Isha', arabic: 'العشاء', icon: 'moon' }
];

export const calculationMethods = [
  { id: 4, name: 'Umm Al-Qura University, Makkah' },
  { id: 2, name: 'Islamic Society of North America (ISNA)' },
  { id: 3, name: 'Muslim World League' },
  { id: 5, name: 'Egyptian General Authority of Survey' },
  { id: 1, name: 'University of Islamic Sciences, Karachi' },
  { id: 15, name: 'Moonsighting Committee Worldwide' },
  { id: 0, name: 'Shia Ithna-Ashari, Leva Institute, Qum' },
  { id: 7, name: 'Institute of Geophysics, University of Tehran' },
  { id: 16, name: 'Dubai (experimental)' },
  { id: 17, name: 'Qatar' },
  { id: 18, name: 'Kuwait' },
  { id: 19, name: 'Singapore' }
];

// Helper to determine if it's night time based on prayer times
export const isNightTime = (prayerTimes) => {
  if (!prayerTimes) return false;
  const now = new Date();
  const currentTime = now.getHours() * 60 + now.getMinutes();
  
  const parseTime = (timeStr) => {
    if (!timeStr) return 0;
    const [hours, minutes] = timeStr.split(':').map(Number);
    return hours * 60 + minutes;
  };
  
  const maghribTime = parseTime(prayerTimes.Maghrib);
  const fajrTime = parseTime(prayerTimes.Fajr);
  
  // Night is after Maghrib or before Fajr
  return currentTime >= maghribTime || currentTime < fajrTime;
};

// Get current/next prayer
export const getCurrentPrayer = (prayerTimes) => {
  if (!prayerTimes) return { current: null, next: null };
  
  const now = new Date();
  const currentTime = now.getHours() * 60 + now.getMinutes();
  
  const parseTime = (timeStr) => {
    if (!timeStr) return 0;
    const [hours, minutes] = timeStr.split(':').map(Number);
    return hours * 60 + minutes;
  };
  
  const prayers = prayerNames.map(p => ({
    ...p,
    time: parseTime(prayerTimes[p.key]),
    timeStr: prayerTimes[p.key]
  }));
  
  // Find current and next prayer
  let current = null;
  let next = null;
  
  for (let i = 0; i < prayers.length; i++) {
    if (currentTime < prayers[i].time) {
      next = prayers[i];
      current = i > 0 ? prayers[i - 1] : prayers[prayers.length - 1];
      break;
    }
  }
  
  // If no next prayer found, we're after Isha
  if (!next) {
    current = prayers[prayers.length - 1];
    next = prayers[0];
  }
  
  return { current, next };
};

// Format time remaining until next prayer
export const getTimeRemaining = (nextPrayerTime) => {
  if (!nextPrayerTime) return '';
  
  const now = new Date();
  const currentMinutes = now.getHours() * 60 + now.getMinutes();
  const [hours, minutes] = nextPrayerTime.split(':').map(Number);
  let targetMinutes = hours * 60 + minutes;
  
  // If target is earlier than current, it's tomorrow
  if (targetMinutes <= currentMinutes) {
    targetMinutes += 24 * 60;
  }
  
  const diff = targetMinutes - currentMinutes;
  const h = Math.floor(diff / 60);
  const m = diff % 60;
  
  if (h > 0) {
    return `${h}h ${m}m until`;
  }
  return `${m}m until`;
};
